/* Veteran Survival Gear — storefront behaviour.
   Everything is delegated from the document so sections re-rendered by the
   theme editor keep working without re-binding. */
(function () {
  'use strict';

  /* ---------- product gallery ---------- */
  function selectMedia(gallery, index) {
    var slides = gallery.querySelectorAll('[data-vsg-slide]');
    var thumbs = gallery.querySelectorAll('[data-vsg-thumb]');
    for (var i = 0; i < slides.length; i++) {
      slides[i].hidden = String(i) !== String(index);
    }
    for (var j = 0; j < thumbs.length; j++) {
      thumbs[j].setAttribute('aria-current', thumbs[j].dataset.vsgThumb === String(index) ? 'true' : 'false');
    }
  }

  /* ---------- product gallery: the thumbnail rail pages, it does not scroll
     ----------------------------------------------------------------------
     A scrolling rail leaves the thumbnails it has not reached with layout
     boxes outside the rail, which puts one of them under the next arrow even
     though nothing of it is painted there. Paging hides them instead, so the
     track never overflows and no thumbnail has a box under a control. */
  function thumbPage(gallery, delta) {
    if (!gallery) return;
    var track = gallery.querySelector('[data-vsg-track]');
    if (!track) return;
    var thumbs = track.querySelectorAll('[data-vsg-thumb]');
    if (!thumbs.length) return;

    /* Measure with the whole rail shown; a hidden thumbnail has no box. */
    var i;
    for (i = 0; i < thumbs.length; i++) thumbs[i].hidden = false;
    var cs = getComputedStyle(track);
    var gap = parseFloat(cs.columnGap || cs.gap) || 0;
    var pad = (parseFloat(cs.paddingLeft) || 0) + (parseFloat(cs.paddingRight) || 0);
    var tile = thumbs[0].getBoundingClientRect().width;
    var room = track.clientWidth - pad;
    var per = tile > 0 ? Math.max(1, Math.floor((room + gap) / (tile + gap))) : thumbs.length;
    var pages = Math.max(1, Math.ceil(thumbs.length / per));

    var page = parseInt(track.dataset.vsgPage || '0', 10) + (delta || 0);
    if (page < 0) page = 0;
    if (page > pages - 1) page = pages - 1;
    track.dataset.vsgPage = String(page);

    for (i = 0; i < thumbs.length; i++) {
      thumbs[i].hidden = i < page * per || i >= (page + 1) * per;
    }

    var arrows = gallery.querySelectorAll('[data-vsg-arrow]');
    for (i = 0; i < arrows.length; i++) {
      arrows[i].hidden = pages < 2;
      arrows[i].disabled = arrows[i].dataset.vsgArrow === 'next' ? page >= pages - 1 : page <= 0;
    }
  }

  /* ---------- pack selector ---------- */
  /* The form quantity is deliberately left at 1. A Whop plan charges per
     checkout and ignores a quantity param, so a multi-unit pack is its own
     checkout URL carried on the tile (data-vsg-checkout), never a quantity. */
  function syncPacks(root) {
    var packs = root.querySelectorAll('[data-vsg-pack]');
    var selected = null;
    for (var i = 0; i < packs.length; i++) {
      var input = packs[i].querySelector('input[type="radio"]');
      var on = !!(input && input.checked);
      packs[i].setAttribute('data-selected', on ? 'true' : 'false');
      if (on) selected = packs[i];
    }
    var total = root.querySelector('[data-vsg-running-total]');
    if (selected && total) total.textContent = selected.dataset.vsgTotal || '';
  }

  /* ---------- tab groups (how-it-works, kit explorer) ---------- */
  function selectTab(group, value) {
    var tabs = group.querySelectorAll('[data-vsg-tab]');
    var panes = group.querySelectorAll('[data-vsg-pane]');
    for (var i = 0; i < tabs.length; i++) {
      tabs[i].setAttribute('aria-selected', tabs[i].dataset.vsgTab === value ? 'true' : 'false');
    }
    for (var j = 0; j < panes.length; j++) {
      panes[j].hidden = panes[j].dataset.vsgPane !== value;
    }
  }

  document.addEventListener('click', function (event) {
    var el = event.target.closest ? event.target : event.target.parentElement;
    if (!el || !el.closest) return;

    var thumb = el.closest('[data-vsg-thumb]');
    if (thumb) {
      var gal = thumb.closest('[data-vsg-gallery]');
      if (gal) selectMedia(gal, thumb.dataset.vsgThumb);
      return;
    }

    var arrow = el.closest('[data-vsg-arrow]');
    if (arrow) {
      thumbPage(arrow.closest('[data-vsg-gallery]'), arrow.dataset.vsgArrow === 'next' ? 1 : -1);
      return;
    }

    var tab = el.closest('[data-vsg-tab]');
    if (tab) {
      var group = tab.closest('[data-vsg-tabgroup]');
      if (group) selectTab(group, tab.dataset.vsgTab);
      return;
    }

    /* ---------- mobile drawer ---------- */
    if (el.closest('[data-vsg-drawer-open]')) {
      setDrawer(true);
      return;
    }
    if (el.closest('[data-vsg-drawer-close]')) {
      setDrawer(false);
      return;
    }
    /* A link inside the drawer navigates; close it so a same-page anchor does
       not leave the panel sitting over the target. */
    var drawerLink = el.closest('[data-vsg-drawer] a');
    if (drawerLink) {
      setDrawer(false);
      return;
    }

    /* Only one desktop dropdown open at a time, and a click anywhere else
       shuts the open one. <details> has no built-in exclusivity. */
    var inDrop = el.closest('[data-vsg-drop]');
    var drops = document.querySelectorAll('[data-vsg-drop]');
    for (var d = 0; d < drops.length; d++) {
      if (drops[d] !== inDrop) drops[d].removeAttribute('open');
    }
  });

  function setDrawer(open) {
    var drawer = document.querySelector('[data-vsg-drawer]');
    if (!drawer) return;
    drawer.setAttribute('data-open', open ? 'true' : 'false');
    document.documentElement.style.overflow = open ? 'hidden' : '';
    var btn = document.querySelector('[data-vsg-drawer-open]');
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') setDrawer(false);
  });

  document.addEventListener('change', function (event) {
    var pack = event.target.closest && event.target.closest('[data-vsg-pack]');
    if (!pack) return;
    var form = pack.closest('[data-vsg-buyform]');
    if (form) syncPacks(form);
  });


  /* ---- card carousel under the buy box ------------------------------- */
  /* One page is whatever is in view, so the dot count follows the layout
     rather than a hard-coded slides-per-view. */

  function ugcPages(track) {
    var card = track.querySelector('.vsg-ugc__card');
    if (!card) return 1;
    var per = Math.max(1, Math.round(track.clientWidth / (card.offsetWidth + 8)));
    var total = track.querySelectorAll('.vsg-ugc__card').length;
    return Math.max(1, Math.ceil(total / per));
  }

  function ugcPage(track) {
    var pages = ugcPages(track);
    var span = track.scrollWidth - track.clientWidth;
    if (span <= 1) return 0;
    return Math.min(pages - 1, Math.round(track.scrollLeft / span * (pages - 1)));
  }

  function ugcSync(frame) {
    var track = frame.querySelector('[data-vsg-ugc-track]');
    var dots = frame.parentNode.querySelector('[data-vsg-ugc-dots]');
    if (!track || !dots) return;
    var pages = ugcPages(track);
    if (dots.children.length !== pages) {
      dots.innerHTML = '';
      for (var i = 0; i < pages; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'vsg-ugc__dot';
        b.setAttribute('data-vsg-ugc-dot', String(i));
        b.setAttribute('aria-label', 'Go to page ' + (i + 1));
        dots.appendChild(b);
      }
    }
    var cur = ugcPage(track);
    for (var j = 0; j < dots.children.length; j++) {
      dots.children[j].setAttribute('aria-current', j === cur ? 'true' : 'false');
    }
  }

  function ugcGo(frame, page) {
    var track = frame.querySelector('[data-vsg-ugc-track]');
    if (!track) return;
    var pages = ugcPages(track);
    var span = track.scrollWidth - track.clientWidth;
    var target = pages > 1 ? span * (page / (pages - 1)) : 0;
    track.scrollTo({ left: Math.max(0, Math.min(span, target)), behavior: 'smooth' });
  }

  function initUgc() {
    var frames = document.querySelectorAll('[data-vsg-ugc]');
    for (var i = 0; i < frames.length; i++) {
      (function (frame) {
        var track = frame.querySelector('[data-vsg-ugc-track]');
        if (track && !track.dataset.vsgBound) {
          track.dataset.vsgBound = '1';
          track.addEventListener('scroll', function () { ugcSync(frame); });
          window.addEventListener('resize', function () { ugcSync(frame); });
        }
        ugcSync(frame);
      })(frames[i]);
    }
    initUgcVideo();
  }

  /* The carousel cards hold muted looping clips. They start themselves where
     the browser allows it; the control over the card is the way back in when
     it does not, and the way to stop one. */
  function initUgcVideo() {
    var vids = document.querySelectorAll('[data-vsg-ugc] video');
    for (var i = 0; i < vids.length; i++) {
      (function (v) {
        if (v.dataset.vsgBound) return;
        v.dataset.vsgBound = '1';
        var card = v.closest('.vsg-ugc__card');
        var mark = function () {
          if (card) card.setAttribute('data-playing', v.paused ? 'false' : 'true');
        };
        v.addEventListener('play', mark);
        v.addEventListener('pause', mark);
        v.muted = true;
        var p = v.play();
        if (p && p.catch) p.catch(function () { mark(); });
        mark();
      })(vids[i]);
    }
  }

  document.addEventListener('click', function (event) {
    var play = event.target.closest && event.target.closest('[data-vsg-ugc-play]');
    if (play) {
      var card = play.closest('.vsg-ugc__card');
      var vid = card && card.querySelector('video');
      if (vid) {
        if (vid.paused) { vid.muted = true; vid.play(); } else { vid.pause(); }
      }
      return;
    }
    var arrow = event.target.closest && event.target.closest('[data-vsg-ugc-arrow]');
    if (arrow) {
      var frame = arrow.closest('[data-vsg-ugc]');
      var track = frame.querySelector('[data-vsg-ugc-track]');
      var step = arrow.dataset.vsgUgcArrow === 'next' ? 1 : -1;
      ugcGo(frame, Math.max(0, Math.min(ugcPages(track) - 1, ugcPage(track) + step)));
      return;
    }
    var dot = event.target.closest && event.target.closest('[data-vsg-ugc-dot]');
    if (dot) {
      var wrap = dot.closest('.vsg-wrap') || document;
      var f = wrap.querySelector('[data-vsg-ugc]');
      if (f) ugcGo(f, parseInt(dot.dataset.vsgUgcDot, 10) || 0);
    }
  });

  function init() {
    var forms = document.querySelectorAll('[data-vsg-buyform]');
    for (var i = 0; i < forms.length; i++) syncPacks(forms[i]);
    var groups = document.querySelectorAll('[data-vsg-tabgroup]');
    for (var j = 0; j < groups.length; j++) {
      var first = groups[j].querySelector('[data-vsg-tab]');
      if (first) selectTab(groups[j], first.dataset.vsgTab);
    }
    var gals = document.querySelectorAll('[data-vsg-gallery]');
    for (var k = 0; k < gals.length; k++) {
      selectMedia(gals[k], 0);
      thumbPage(gals[k], 0);
    }
    setDrawer(false);
    initUgc();
  }

  /* The rail holds a different number of thumbnails per page at each width. */
  window.addEventListener('resize', function () {
    var gals = document.querySelectorAll('[data-vsg-gallery]');
    for (var i = 0; i < gals.length; i++) thumbPage(gals[i], 0);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
